import { useAuth } from "../context/AuthContext";
import GoldSectionLayout from "../components/GoldSectionLayout";
import MissAnalyzerPanel from "../components/MissAnalyzerPanel";

export default function GoldMissAnalyzerPage() {
  const { token, user } = useAuth();
  return (
    <GoldSectionLayout
      title="Miss Analyzer"
      subtitle="Self-learning post-mortems. Every miss is dissected and fed back into predictor weights."
      testid="gold-miss-analyzer-page"
    >
      <MissAnalyzerPanel token={token} isAdmin={!!user?.is_admin} />
    </GoldSectionLayout>
  );
}
